import { getGscRedirectStaticUri, GOOGLE_OAUTH_API_URL } from '../const';

/**
 * Строит URL авторизации Google для подключения Search Console.
 *
 * Используется authorization code flow (response_type=code): Google возвращает
 * одноразовый code в query на статичный redirect_uri корневого домена, бэкенд
 * обменивает его на токены. client_id/scope/state приходят с бэкенда.
 *
 * @kind helper
 * @returns URL страницы авторизации Google
 */
export const getGscOauthUrl = ({
    client_id,
    scope,
    state_token,
}: {
    client_id: string;
    scope?: string[];
    state_token: string;
}) => {
    const params = new URLSearchParams();
    const scopeString = (scope || []).join(' ');

    params.set('response_type', 'code');
    params.set('client_id', client_id);
    params.set('redirect_uri', getGscRedirectStaticUri());
    params.set('scope', scopeString);
    params.set('state', state_token);
    params.set('access_type', 'offline');
    params.set('include_granted_scopes', 'true');
    params.set('prompt', 'consent');

    /*
     * URLSearchParams сериализует пробелы как "+", а бэкенд при сверке
     * redirect_uri/scope ждёт percent-encoding (`%20`).
     */
    return `${GOOGLE_OAUTH_API_URL}?${params.toString().replace(/\+/g, '%20')}`;
};
